module.exports = __webpack_public_path__ + "img/life-tokens.ee531c1d.svg";